import { useLang } from "../context/LanguageContext";
import { useScrollReveal } from "../hooks/useScrollReveal";
import usePageSeo from "../hooks/usePageSeo";
import "./Showcase.css";

const IMAGES = [
  { src: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=80&fit=crop", name: "Solid Oak Sofa" },
  { src: "https://images.unsplash.com/photo-1567538096621-38d2284b23ff?w=800&q=80&fit=crop", name: "Modern Lounge Chair" },
  { src: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=800&q=80&fit=crop", name: "Walnut Media Console" },
  { src: "https://images.unsplash.com/photo-1540574163026-643ea20ade25?w=800&q=80&fit=crop", name: "Master Bedroom Set" },
  { src: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=800&q=80&fit=crop", name: "Oak Dining Table" },
  { src: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=800&q=80&fit=crop", name: "Mid-Century Desk" },
  { src: "https://images.unsplash.com/photo-1506439773649-6e0eb8cfb237?w=800&q=80&fit=crop", name: "Floating Shelf" },
  { src: "https://images.unsplash.com/photo-1617104678098-de229db51175?w=800&q=80&fit=crop", name: "Walnut Coffee Table" },
  { src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80&fit=crop", name: "Artisan Details" },
  { src: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=800&q=80&fit=crop", name: "Living Room Set" },
  { src: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80&fit=crop", name: "Custom Bookcase" },
  { src: "https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?w=800&q=80&fit=crop", name: "Elegant Wooden Door" },
];

export default function Showcase() {
  useScrollReveal();
  const { t, lang } = useLang();

  usePageSeo({
    lang,
    path: "/showcase",
    title: lang === "IT"
      ? "Showcase | Ispirazioni e lavorazioni GDM Installations"
      : "Showcase | Inspirations and craftsmanship by GDM Installations",
    description: lang === "IT"
      ? "Una selezione visiva di creazioni, dettagli e ispirazioni nel mondo degli arredi in legno e delle installazioni artigianali."
      : "A visual selection of creations, details and inspirations in bespoke wood furnishings and artisanal installations.",
    keywords: lang === "IT"
      ? "showcase arredi legno, galleria falegnameria, ispirazioni arredo su misura, GDM Installations"
      : "wood furniture showcase, carpentry gallery, bespoke interior inspiration, GDM Installations",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "ImageGallery",
      name: lang === "IT" ? "Showcase GDM Installations" : "GDM Installations Showcase",
      url: "https://gdminstallations.it/showcase",
      associatedMedia: IMAGES.map((image) => ({
        "@type": "ImageObject",
        contentUrl: image.src,
        description: image.name,
      })),
    },
  });

  return (
    <div className="showcase-page">
      <div className="page-hero-mini">
        <h1 className="page-hero-title fade-in">{t.showcase.title}</h1>
        <div className="gold-line" />
        <p className="page-hero-sub fade-in fade-in-delay-1">{t.showcase.subtitle}</p>
      </div>
      <section className="showcase-grid-section section">
        <div className="showcase-grid">
          {IMAGES.map((img, i) => (
            <div key={i} className={`showcase-item fade-in fade-in-delay-${(i % 4) + 1}`}>
              <img src={img.src} alt={img.name} />
              <div className="showcase-overlay">
                <span>{img.name}</span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
